<template>
  <div class="bm-create" >
    <div class="title" >
      创建球队
    </div>
    <van-cell-group>
      <van-cell title="队徽" >
        <template>
          <div class="teamIcon" >
            <img v-if="profileImg" :src="profileImg" alt="">
            <img v-if="!profileImg" src="@/assets/images/team-logo-empty.png">
            <div class="upload-profile-lod" v-show="profileLod" >
              <van-loading type="spinner" />
            </div>
            <van-uploader class="uploader" :after-read="onRead" :disabled="isRead">
              <van-icon name="photograph" />
            </van-uploader>
          </div>
        </template>
      </van-cell>
      <van-cell title="队名" :value="form.name" @click="isShowName=true" is-link />
      <van-cell title="地区" :value="form.areaName" @click="isShowPopup=true" is-link />
      <van-cell title="队服颜色" @click="isShowJesery=true" is-link >
        <img :src="form.jesery.name | formatJeseryIcon" alt="" style="width: 20px;position: relative;top: 3px;"/>
      </van-cell>
    </van-cell-group>
    <!-- 名称输入 start-->
    <van-popup v-model="isShowName" position="right" class="popup" >
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" >
        <van-col>
          <van-cell-group>
            <van-field v-model="form.name" placeholder="请输入球队名称" />
          </van-cell-group>
        </van-col>
        <van-col>
          <van-button type="primary" @click="isShowName=false" >确认</van-button>
        </van-col>
      </van-row>
    </van-popup>
    <!-- end -->

    <van-popup v-model="isShowPopup" position="bottom" >
      <van-picker show-toolbar :columns="columns" value-key="name" @change="onChange"
                  @cancel="onCancel"
                  @confirm="onConfirm" />
    </van-popup>
    <!-- 队服颜色 start -->
    <van-popup v-model="isShowJesery" position="bottom">
      <div class="jesery-action">
        <div class="action-btn" @click="onJeseryCancel">取消</div>
        <div class="action-btn" @click="onJeseryConfirm">确认</div>
      </div>
      <div class="jesery-box">
        <div class="jesery-item" v-for="(item) in jeseryMap" :key="item.code">
          <div class="iocn-box" style="position: relative">
            <img class="jesery-icon" @click="selectJesery(item)" :src="item.name | formatJeseryIcon" alt="" />
            <img class="checked-icon" v-show="selectedJesery.code == item.code" src="@/assets/images/checked.png" alt="" />
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end-->
    <div class="foot" @click="submitAction">
      创建
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import includes from 'lodash/includes'
import { ImageFormat, varConfig } from '@/utils'
import { getQiniuUploadToken } from '@/api/user'
import { createBMTeam, getJerseyMapByType } from '@/api/team'
import { getCityList } from '@/api/city'
import { getMatchInfo, getAreaList } from '@/api/match'

import { Cell, CellGroup, Button, Popup, Field, Row, Col, Picker, Toast, Loading } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Field).use(Row).use(Col).use(Picker).use(Toast).use(Loading)

const bigCityList = ['北京', '上海', '天津', '重庆', '香港', '澳门']
export default {
  name: 'teamEdit',
  data() {
    return {

      isShowName: false,
      form: {
        icon: '',
        jesery: {}
      },
      isShowPopup: false,
      isShowJesery: false,
      sportType: '',
      query: this.$route.query,
      areaList: {},
      cityList: {},
      columns: [],
      isRead: false,
      qiniuToken: '',
      jeseryMap: [],
      selectedJesery: {},
      profileLod: false
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.squareImageView(this.form.icon, 100)
    }
  },
  created() {
    // this.getBMMatchSignUpRule()
    this.getMatchInfo()
    this.getQiniuToken()
    const cityList = this.cityList = getCityList()
    this.columns = [
      {
        values: Object.keys(cityList),
        className: 'column1'
      },
      {
        values: cityList['上海'],
        className: 'column2',
        defaultIndex: 1
      }
    ]
  },
  methods: {
    onRead(file) {
      this.profileLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.form.icon = res.hash
          this.profileLod = false
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.cityList[values[0]])
    },
    submitAction() {
      if (this.form.name) {
        this.createBMTeam()
      } else {
        Toast('缺少球队名称')
      }
    },
    createBMTeam: function () {
      const params = {
        name: this.form.name,
        badge: this.form.icon,
        areaId: this.form.areaId,
        color: this.form.jesery.code
      }
      createBMTeam(params).then(response => {
        const data = response.data
        if (data) {
          Toast('创建成功')
          this.$router.go(-1)
        }
      })
    },
    getMatchInfo: function () {
      getMatchInfo(this.query.matchId).then(response => {
        const data = response.data
        this.sportType = data.match && data.match.sportType
        this.getJerseyMapByType(this.sportType)
      })
    },
    onConfirm(value, index) {
      this.form.areaId = value[1].id
      this.form.areaName = value[0] + '|' + value[1].name
      this.isShowPopup = false
    },
    onCancel() {
      this.isShowPopup = false
    },
    onJeseryConfirm() {
      this.form.jesery = this.selectedJesery
      this.isShowJesery = false
    },
    onJeseryCancel() {
      this.isShowJesery = false
    },
    getJerseyMapByType() {
      this.jeseryMap = getJerseyMapByType(this.sportType)
    },
    selectJesery(jesery) {
      this.selectedJesery = jesery
    },
    getAreaList: function () {
      getAreaList(1).then(response => {
        const data = response.data
        const areaList = data.area
        for (let i = 0; i < areaList.length; i++) {
          let cid = areaList[i].id
          if (includes(bigCityList, areaList[i].name)) {
            cid = parseInt(cid) + 1
          }
          getAreaList(cid).then(res => {
            const data = res.data
            const cityList = data.area
            const name = areaList[i].name
            console.log(name)
            this.areaList[name] = cityList
            console.log(this.areaList[name])
            if (i === 33) {
              console.log(JSON.stringify(this.areaList))
            }
          })
        }
      })
    }
  },
  filters: {
    formatJeseryIcon: function (value) {
      if (value) {
        return varConfig.qiniuCdn + '/' + value
      }
    }
  }
}
</script>

<style lang="stylus">
.bm-create
  background-color: white
  width 100%
  height: 100%
  position absolute
  .uploader
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .van-cell-group
    .van-cell:not(:last-child)::after
      right: 15px
    .van-cell:first-child
      .van-cell__title
        display flex
        align-content center
        align-items: center;
    .van-cell
      font-size:14px;
      font-weight:300;
      color:rgba(74,74,74,1);
      .van-icon::before
        color: #000000
  .teamIcon
    width 50px
    height 50px
    border-radius:2px;
    float: right
    position: relative
    img
      width 50px
      height 50px
    .upload-profile-lod
      position absolute
      left: 0;
      top: 0;
      width 100%
      height: 100%
      background-color white
      .van-loading
        left: 50%
        top: 50%
        transform translate(-50%, -50%)
  .popup
    width 100%
    height: 100%
    background-color white
    .van-button
      background-color #32A377
    .form
      padding: 0 15px;
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    text-align center
    position: absolute
    bottom: 0
    width: 100%
    font-size:20px;
    font-weight:400;
    color:rgba(50,163,119,1);
  .jesery-box
    padding: 10px 15px
    min-height: 135px
    .jesery-item
      width: 25%
      float: left
      text-align: center
      .jesery-icon
        width: 30px
      .checked-icon
        width: 16px
        position: absolute;
        right: 18px;
        bottom: 4px;
  .jesery-action
    display: flex;
    height: 44px;
    line-height: 44px;
    -webkit-box-pack: justify;
    justify-content: space-between
    .action-btn
      color: #1989fa;
      padding: 0 15px;
      font-size: 14px;
</style>



// WEBPACK FOOTER //
// src/pages/invite/create.vue